export default class PendingRecordAttempt
{
	id = null
	submittedOn = null

	userId = null
	userName = null
	
	rocketId = null
	flightId = null
}